import { atom, createStore } from 'jotai'
import { ISectionTypesResponse } from 'src/models/templates/sectionTypes'

export const store = createStore()

export const templateSectionTypesAtom = atom<ISectionTypesResponse[]>([])
